
import { mapState } from 'vuex';
import SquareGallery from './components/SquareGallery.vue';

export default {
  i18nComponentKey: 'WidgetReviewsSquareGallery.WidgetReviewsSquareGalleryPc',
  name: 'WidgetReviewsSquareGalleryPc',
  components: { SquareGallery },
  computed: {
    ...mapState('widget', ['widget']),
    squareGalleryProps() {
      const { layout_column, column_gap, row_gap } = this.widget;
      return {
        cols: layout_column,
        gutter: column_gap,
        rowGap: row_gap
      };
    }
  }
};
